import { useMemo } from 'react';
import { BotMessage, FromMessageEnum, Source, UserMessage } from 'src/types';
import { parseMessage } from 'src/utils/parseMessage';
import { sortByPosition } from 'src/utils/sortByPosition';
import { useChatById } from './api';

interface MessageFromApi {
	id: string;
	question: string;
	answer: string;
	date: string;
	outdated: boolean;
	urls: Record<string, unknown>;
	internetSources?: Source[];
	file?: string;
}

export const useShareList = (chatId: string) => {
	const list = useChatById(chatId) as unknown as MessageFromApi[];

	const messages = useMemo(() => {
		return list?.flatMap((message) => {
			const { question, answer, date, id, outdated, urls, internetSources, file } = message;

			const userMessage: UserMessage = {
				created_time: date,
				from: FromMessageEnum.USER,
				id: `user-${id}`,
				text: question,
				file
			};

			const sources: Source[] = sortByPosition(Object.values(urls || {}));

			const botMessage: BotMessage = {
				completed: true,
				created_time: date,
				feedback: null,
				from: FromMessageEnum.BOT,
				id,
				outdated: outdated || false,
				sources: sources || [],
				internetSources: internetSources || [],
				text: parseMessage(answer, sources),
				internetText: ''
			};

			return [userMessage, botMessage];
		});
	}, [list]);

	return { messages };
};
